import { alpha, styled } from '@mui/material';

export const StudyRulesContent = styled('div')(
	({ theme }) => `
  --surface: ${theme.palette.background.paper};
  --ink: ${theme.palette.text.primary};
  --muted: ${theme.palette.text.secondary};
  --line: ${theme.palette.divider};
  --primary: ${theme.palette.primary.main};
  --primary-soft: ${alpha(theme.palette.primary.main, 0.1)};
  --primary-ink: ${theme.palette.primary.contrastText};
  --ok: ${theme.palette.success.contrastText};
  --ok-soft: ${theme.palette.success.main};
  --warn: ${theme.palette.warning.contrastText};
  --warn-soft: ${theme.palette.warning.main};
  --bad: ${theme.palette.error.contrastText};
  --bad-soft: ${theme.palette.error.main};
    --local-soft: ${theme.palette.action.hover};
  display: grid;
  gap: 24px;
  min-width: 0;
  color: var(--ink);
  font-family: ${theme.typography.fontFamily};
  font-size: 15px;
  line-height: 1.6;
  & * { box-sizing: border-box; }
  & {
    h1,
    h2,
    h3 {
      margin: 0;
      text-wrap: balance;
    }
    h1 {
      font-size: 28px;
      font-weight: 800;
      letter-spacing: -0.01em;
    }
    h2 {
      font-size: 19px;
      font-weight: 800;
    }
    h3 {
      font-size: 15px;
      font-weight: 700;
    }
    p {
      margin: 0;
    }
    .eyebrow {
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      color: var(--muted);
    }
    .muted {
      color: var(--muted);
    }
    .card {
      background: var(--surface);
      border-radius: 18px;
      padding: 22px;
      box-shadow: 0 1px 3px rgba(30, 50, 90, 0.05);
      display: grid;
      gap: 14px;
      align-content: start;
      min-width: 0;
    }
    .sub {
      font-size: 14px;
      color: var(--muted);
      margin-top: 4px;
    }
    
    .years {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr)) minmax(0, 0.8fr);
      gap: 4px;
    }
    .yr {
      background: var(--local-soft);
      border-radius: 10px;
      padding: 10px 12px;
      display: grid;
      gap: 1px;
      align-content: start;
    }
    .yr b {
      font-size: 14px;
    }
    .yr span {
      font-size: 12.5px;
      color: var(--muted);
      font-variant-numeric: tabular-nums;
    }
    .yr em {
      font-style: normal;
      font-size: 11px;
      font-weight: 800;
      color: var(--primary-ink);
      background: var(--primary);
      border-radius: 999px;
      padding: 1px 8px;
      width: max-content;
      margin-top: 4px;
    }
    .yr.now {
      background: var(--primary-soft);
      box-shadow: inset 0 0 0 1.5px var(--primary);
    }
    .yr.now b {
      color: var(--primary);
    }
    .yr.grad {
      background: var(--ok-soft);
    }
    .yr.grad b {
      color: var(--ok);
    }
    .entry {
      border-collapse: collapse;
      width: 100%;
      font-size: 13px;
      text-align: center;
      font-variant-numeric: tabular-nums;
    }
    .entry caption {
      text-align: left;
      font-size: 12.5px;
      color: var(--muted);
      font-weight: 700;
      margin-bottom: 6px;
    }
    .entry th {
      font-weight: 600;
      color: var(--muted);
      padding: 4px;
      border-bottom: 1px solid var(--line);
    }
    .entry td {
      padding: 6px 4px;
      font-weight: 700;
    }
    .entry td.on {
      color: var(--primary);
    }
    .assess {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 12px;
    }
    .as {
      border: 1px solid var(--line);
      border-radius: 14px;
      padding: 14px;
      display: grid;
      gap: 8px;
      align-content: start;
      border-top: 4px solid var(--k);
    }
    .t-as {
      --k: var(--muted);
    }
    .t-for {
      --k: var(--primary);
    }
    .t-of {
      --k: var(--ok);
      background: var(--ok-soft);
      border-color: transparent;
      border-top-color: var(--ok);
    }
    .as-top {
      display: flex;
      justify-content: space-between;
      gap: 8px;
      flex-wrap: wrap;
      align-items: center;
    }
    .as-kind {
      font-size: 12px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: var(--k);
    }
    .as-badge {
      font-size: 11.5px;
      font-weight: 800;
      border-radius: 999px;
      padding: 2px 9px;
      background: var(--surface);
      color: var(--k);
      border: 1px solid var(--k);
    }
    .as p {
      font-size: 13.5px;
      color: var(--muted);
    }
    .as dl {
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 4px 10px;
      margin: 4px 0 0;
      font-size: 13px;
      border-top: 1px solid var(--line);
      padding-top: 8px;
    }
    .as dt {
      color: var(--muted);
    }
    .as dd {
      margin: 0;
    }
    .flow {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 6px 8px;
      font-size: 13px;
    }
    .f-step {
      font-weight: 700;
      border-radius: 9px;
      padding: 5px 11px;
      background: var(--local-soft);
    }
    .f-of {
      background: var(--ok-soft);
      color: var(--ok);
    }
    .f-res {
      background: var(--ok);
      color: var(--surface);
    }
    .f-arr {
      color: var(--muted);
      font-size: 12px;
    }
    .f-arr::after {
      content: " →";
    }
    .tips {
      display: grid;
      gap: 6px;
    }
    .tips ul {
      margin: 0;
      padding-left: 18px;
      display: grid;
      gap: 4px;
      color: var(--muted);
      font-size: 14px;
    }
    .tips b {
      color: var(--ink);
    }
    .grad-date {
      background: var(--ok-soft);
      border-radius: 12px;
      padding: 12px 14px;
      display: grid;
      gap: 2px;
    }
    .grad-date span {
      font-size: 12px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: var(--ok);
    }
    .grad-date b {
      font-size: 24px;
      font-weight: 800;
      color: var(--ok);
      line-height: 1.15;
    }
    .grad-date small {
      font-size: 13px;
      color: var(--muted);
    }
    .entry tr th:first-child {
      text-align: left;
      color: var(--muted);
      font-weight: 600;
      padding-left: 0;
    }
    .pace {
      margin: 0;
      padding-left: 18px;
      display: grid;
      gap: 5px;
      font-size: 14px;
      color: var(--muted);
    }
    .pace b {
      color: var(--ink);
    }
    .stats {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 10px;
    }
    .stat {
      border-radius: 14px;
      padding: 12px 14px;
      display: grid;
      gap: 2px;
    }
    .stat .n {
      font-size: 26px;
      font-weight: 800;
      line-height: 1.1;
      font-variant-numeric: tabular-nums;
    }
    .stat span {
      font-size: 13px;
    }
    .s-done {
      background: var(--ok-soft);
      color: var(--ok);
    }
    .s-active {
      background: var(--primary-soft);
      color: var(--primary);
    }
    .s-paid {
      background: var(--primary-soft);
      color: var(--primary);
    }
    .s-todo {
      background: var(--local-soft);
      color: var(--muted);
    }
    .list {
      display: grid;
    }
    .row {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 4px 12px;
      align-items: center;
      padding: 11px 0;
      border-top: 1px solid var(--line);
    }
    .row:first-child {
      border-top: 0;
    }
    .row b {
      font-weight: 700;
    }
    .row small {
      grid-column: 1;
      font-size: 13px;
      color: var(--muted);
    }
    .badge {
      grid-row: span 2;
      font-size: 12px;
      font-weight: 700;
      border-radius: 8px;
      padding: 3px 9px;
      white-space: nowrap;
      justify-self: end;
    }
    .b-done {
      background: var(--ok-soft);
      color: var(--ok);
    }
    .b-active {
      background: var(--primary-soft);
      color: var(--primary);
    }
    .b-buy {
      background: var(--warn-soft);
      color: var(--warn);
    }
    .b-lock {
      background: var(--local-soft);
      color: var(--muted);
    }
    
    .reqs {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 12px;
    }
    .req {
      border: 1px solid var(--line);
      border-radius: 14px;
      padding: 14px;
      display: grid;
      gap: 4px;
      align-content: start;
    }
    .req .v {
      font-size: 24px;
      font-weight: 800;
      color: var(--primary);
      line-height: 1.1;
    }
    .req p {
      font-size: 13.5px;
      color: var(--muted);
    }
    
    .steps {
      list-style: none;
      margin: 0;
      padding: 0;
      display: grid;
      grid-template-columns: repeat(5, minmax(0, 1fr));
      gap: 12px;
      counter-reset: s;
    }
    .steps li {
      counter-increment: s;
      display: grid;
      gap: 6px;
      align-content: start;
    }
    .steps li::before {
      content: counter(s);
      width: 30px;
      height: 30px;
      border-radius: 9px;
      background: var(--primary-soft);
      color: var(--primary);
      font-weight: 800;
      display: grid;
      place-items: center;
    }
    .steps p {
      font-size: 13.5px;
      color: var(--muted);
    }
    .pass {
      display: flex;
      gap: 16px;
      align-items: center;
      background: var(--ok-soft);
      border-radius: 14px;
      padding: 14px 16px;
      flex-wrap: wrap;
    }
    .pass .big {
      font-size: 30px;
      font-weight: 800;
      color: var(--ok);
      line-height: 1;
    }
    .pass p {
      flex: 1;
      min-width: 220px;
    }
    
    .two {
      display: grid;
      grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
      gap: 16px;
    }
    .big10 {
      font-size: 30px;
      font-weight: 800;
      line-height: 1.1;
    }
    .course {
      border: 1px solid var(--line);
      border-radius: 14px;
      padding: 14px;
      display: grid;
      gap: 10px;
    }
    .course .top {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      flex-wrap: wrap;
      align-items: start;
    }
    .pill {
      font-size: 12px;
      font-weight: 700;
      border-radius: 8px;
      padding: 3px 9px;
      white-space: nowrap;
    }
    .p-ok {
      background: var(--ok-soft);
      color: var(--ok);
    }
    .p-warn {
      background: var(--warn-soft);
      color: var(--warn);
    }
    .bar {
      height: 8px;
      border-radius: 9px;
      background: var(--line);
      overflow: hidden;
    }
    .bar i {
      display: block;
      height: 100%;
      background: var(--warn);
      border-radius: 9px;
    }
    .meta {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      color: var(--muted);
      font-variant-numeric: tabular-nums;
      flex-wrap: wrap;
      gap: 6px;
    }
    .meta b {
      color: var(--ink);
    }
    .alert {
      background: var(--bad-soft);
      border-radius: 14px;
      padding: 16px;
      display: grid;
      gap: 8px;
    }
    .alert h2 {
      color: var(--bad);
    }
    .alert ul {
      margin: 0;
      padding-left: 18px;
      display: grid;
      gap: 4px;
    }
    details {
      border-top: 1px solid var(--line);
      padding: 12px 0;
    }
    details:first-of-type {
      border-top: 0;
    }
    summary {
      cursor: pointer;
      font-weight: 700;
      list-style: none;
      display: flex;
      justify-content: space-between;
      gap: 12px;
    }
    summary::-webkit-details-marker {
      display: none;
    }
    summary::after {
      content: "+";
      color: var(--primary);
      font-weight: 800;
      font-size: 18px;
      line-height: 1;
    }
    details[open] summary::after {
      content: "–";
    }
    details p {
      margin-top: 6px;
      color: var(--muted);
    }
    summary:focus-visible {
      outline: 2px solid var(--primary);
      outline-offset: 2px;
      border-radius: 6px;
    }
    .example {
      font-size: 12px;
      font-weight: 700;
      color: var(--muted);
      background: var(--local-soft);
      border-radius: 6px;
      padding: 2px 8px;
      width: max-content;
    }
    @media (max-width: 900px) {
      .stats {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
      .assess {
        grid-template-columns: 1fr;
      }
      .years {
        grid-template-columns: 1fr 1fr;
      }
      .reqs,
      .two {
        grid-template-columns: 1fr;
      }
      .steps {
        grid-template-columns: 1fr;
      }
      .steps li {
        grid-template-columns: 30px 1fr;
        column-gap: 12px;
      }
      .steps li::before {
        grid-row: span 2;
      }
    }
  }
  & .card { border: 1px solid var(--line); box-shadow: none; border-radius: 20px; padding: 24px; }
  & .table-scroll { min-width: 0; overflow-x: auto; }
  & .entry { min-width: 380px; }
  & .row { grid-template-columns: minmax(0, 1fr) auto; }
  & .row .badge { grid-column: 2; grid-row: span 2; }
  & summary { min-height: 44px; align-items: center; }
  & .f-res { background: var(--ok-soft); color: var(--ok); border: 1px solid var(--ok); }
  @media (max-width: 600px) {
    gap: 16px;
    & .card { padding: 16px; border-radius: 16px; }
    & h1 { font-size: 24px; }
    & .big10 { font-size: 24px; }
    & .row { grid-template-columns: minmax(0, 1fr); gap: 6px; }
    & .row .badge { grid-column: 1; grid-row: auto; justify-self: start; white-space: normal; }
    & .row small { grid-row: 2; }
    & .pass p { min-width: 0; flex-basis: 100%; }
    & .as dl { grid-template-columns: 1fr; }
  }
`,
);
